export default __webpack_public_path__ + "static/needlefiledig-b9cdcfc15777bc90eb262f5481ecc7e0.png";